import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingAutomationRule.List.IRequest;
type Response = Api.Core.ProductPricingAutomationRule.List.IResponse;
type Headers = Api.Core.ProductPricingAutomationRule.List.IHeaders;
const url = '/api/ProductManagement/ProductPricingAutomationRule';
export default async function productPricingAutomationRuleListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
